document.addEventListener('DOMContentLoaded',function(){
﻿// Carolyn Fabrics — Smart Search
// Uses Shopify Predictive Search API + fuzzy scoring fallback
(function(){
  "use strict";

  var overlay=document.getElementById("search-overlay");
  var input=document.getElementById("search-input");
  var results=document.getElementById("search-results");
  var suggestions=document.getElementById("search-suggestions");
  var clearBtn=document.getElementById("search-clear");
  var closeBtn=document.getElementById("search-close");
  var backdrop=document.getElementById("search-backdrop");
  var toggleBtns=document.querySelectorAll("[data-search-toggle]");

  if(!overlay||!input) return;

  var debounceTimer=null;
  var currentQuery="";
  var isOpen=false;

  function normalizePublicSearchQuery(q){
    return String(q||"").replace(/\bchallenger\b/ig,"Pinnacle").replace(/\bchall\b/ig,"PIN");
  }

  function isProductSearchable(p){
    if(!p) return false;
    if(p.available===false) return false;
    var tags=Array.isArray(p.tags)?p.tags.join(','):String(p.tags||'');
    tags=tags.toLowerCase();
    if(tags.indexOf('hidden-from-search')!==-1) return false;
    if(tags.indexOf('nav:exclude')!==-1) return false;
    return true;
  }

  function routedSearchUrl(q){
    var s=String(q||"").toLowerCase().replace(/[^a-z0-9\s-]/g," ").replace(/\s+/g," ").trim();
    if(!s) return "";

    if(/\b(stay cool|cool touch)\b/.test(s)) return "/collections/marine-stay-cool-vinyl";
    if(/\b(marine suede|boat suede|suede vinyl)\b/.test(s)) return "/collections/marine-suede-vinyl";
    if(/\b(budget marine|cheap marine|economy marine)\b/.test(s)) return "/collections/marine-budget-vinyl";
    if(/\b(plain marine|smooth marine)\b/.test(s)) return "/collections/marine-plain-vinyl";
    if(/\b(textured marine|specialty marine|texture marine)\b/.test(s)) return "/collections/marine-textured-vinyl";
    if(/\b(boat seat|boat seats|boat upholstery|pontoon|marine upholstery|marine vinyl|marine grade|boat vinyl|bimini seat)\b/.test(s)) return "/collections/marine-vinyl";

    if(/\b(restaurant|booth|booths|hospitality|bar stool|barstool|diner|banquette)\b/.test(s)) return "/collections/contract-restaurant-hospitality-vinyl";
    if(/\b(medical|healthcare|health care|exam table|clinic|dental|doctor office|vet|veterinary)\b/.test(s)) return "/collections/contract-healthcare-vinyl";
    if(/\b(gym|fitness|weight bench|exercise|workout)\b/.test(s)) return "/collections/contract-gym-fitness-vinyl";
    if(/\b(aviation|airplane|aircraft|plane seat|pilot seat)\b/.test(s)) return "/collections/contract-aviation-vinyl";
    if(/\b(contract vinyl|commercial vinyl|commercial upholstery|heavy duty vinyl)\b/.test(s)) return "/collections/contract";

    if(/\b(awning|bimini top|boat cover|outdoor fabric|patio fabric|patio furniture)\b/.test(s)) return "/collections/outdoor-fabrics";
    if(/\b(thread|sunguard thread|polyester thread|bonded thread)\b/.test(s)) return "/collections/thread";
    if(/\b(sew foam|sea foam|foam)\b/.test(s)) return "/collections/sew-foam";
    if(/\b(scissors|shears)\b/.test(s)) return "/collections/scissors";
    if(/\b(sample|samples|swatch|swatches|sample card)\b/.test(s)) return "/collections/samples";

    if(/\b(diamond cnc|diamond panel|diamond stitch)\b/.test(s)) return "/collections/cnc-diamond-patterns";
    if(/\b(hex|hexagon|hexagon cnc)\b/.test(s)) return "/collections/cnc-hexagon-patterns";
    if(/\b(wave|flow|wave cnc)\b/.test(s)) return "/collections/cnc-wave-flow-patterns";
    if(/\b(cnc|sewn panel|stitched panel|custom panel|upholstery panel)\b/.test(s)) return "/collections/cnc-sewn-patterns";

    return "";
  }

  function suggestedSearchLinks(q){
    var s=String(q||"").toLowerCase();
    var links=[];
    function add(title,url){ links.push({title:title,url:url}); }
    if(/boat|marine|seat|pontoon|bimini/.test(s)){
      add("Marine Vinyl","/collections/marine-vinyl");
      add("Stay Cool Marine Vinyl","/collections/marine-stay-cool-vinyl");
      add("CNC Sewn Panels","/collections/cnc-sewn-patterns");
    }
    if(/restaurant|booth|hospitality|bar|commercial/.test(s)){
      add("Restaurant & Hospitality Vinyl","/collections/contract-restaurant-hospitality-vinyl");
      add("Contract Vinyl","/collections/contract");
      add("Naugahyde","/collections/naugahyde");
    }
    if(/medical|health|healthcare|exam|clinic|dental|vet/.test(s)){
      add("Healthcare Vinyl","/collections/contract-healthcare-vinyl");
      add("Silvertex","/products/silvertex");
      add("Contract Vinyl","/collections/contract");
    }
    if(/cnc|panel|stitch|diamond|hex|quilt|sewn/.test(s)){
      add("CNC Sewn Patterns","/collections/cnc-sewn-patterns");
      add("CNC Diamond Patterns","/collections/cnc-diamond-patterns");
      add("Panel Gallery","/pages/cnc-panel-gallery");
    }
    if(/sample|swatch/.test(s)){
      add("Material Samples","/collections/samples");
      add("Marine Vinyl","/collections/marine-vinyl");
      add("Contract Vinyl","/collections/contract");
    }
    if(!links.length){
      add("Marine Vinyl","/collections/marine-vinyl");
      add("Contract Vinyl","/collections/contract");
      add("CNC Panels","/collections/cnc-sewn-patterns");
    }
    var seen={};
    return links.filter(function(link){
      if(seen[link.url]) return false;
      seen[link.url]=true;
      return true;
    }).slice(0,4);
  }

  // ── Open / Close ─────────────────────────────────────────────────
  function openSearch(){
    overlay.removeAttribute("hidden");overlay.style.display="flex";
    overlay.setAttribute("aria-hidden","false");
    document.body.style.overflow="hidden";
    isOpen=true;
    setTimeout(function(){input.focus();},80);
  }
  function closeSearch(){
    overlay.setAttribute("hidden","");overlay.style.display="";
    overlay.setAttribute("aria-hidden","true");
    document.body.style.overflow="";
    isOpen=false;
    input.value="";
    currentQuery="";
    showSuggestions();
  }

  toggleBtns.forEach(function(btn){
    btn.addEventListener("click",function(){isOpen?closeSearch():openSearch();});
  });
  if(closeBtn) closeBtn.addEventListener("click",closeSearch);
  if(backdrop) backdrop.addEventListener("click",closeSearch);
  document.addEventListener("keydown",function(e){
    if(e.key==="Escape"&&isOpen) closeSearch();
    if((e.key==="k"&&(e.metaKey||e.ctrlKey))){e.preventDefault();isOpen?closeSearch():openSearch();}
  });

  // ── Input ────────────────────────────────────────────────────────
  input.addEventListener("input",function(){
    var q=normalizePublicSearchQuery(input.value.trim());
    if(clearBtn) clearBtn.hidden=q.length===0;
    if(q.length===0){showSuggestions();return;}
    if(q===currentQuery) return;
    currentQuery=q;
    clearTimeout(debounceTimer);
    debounceTimer=setTimeout(function(){doSearch(q);},220);
  });
  if(clearBtn) clearBtn.addEventListener("click",function(){
    input.value="";currentQuery="";clearBtn.hidden=true;input.focus();showSuggestions();
  });

  input.addEventListener("keydown",function(e){
    if(e.key==="Enter"&&currentQuery){
      window.location.href=routedSearchUrl(currentQuery)||("/search?q="+encodeURIComponent(normalizePublicSearchQuery(currentQuery))+"&type=product");
    }
  });

  function showSuggestions(){
    results.innerHTML="";
    results.hidden=true;
    if(suggestions) suggestions.hidden=false;
  }

  // ── Fuzzy score (simple) ─────────────────────────────────────────
  function fuzzyScore(str, query){
    str=str.toLowerCase(); query=query.toLowerCase();
    if(str===query) return 100;
    if(str.startsWith(query)) return 90;
    if(str.includes(query)) return 75;
    // Token match
    var qTokens=query.split(/\s+/);
    var hits=qTokens.filter(function(t){return t.length>1&&str.includes(t);}).length;
    if(hits===qTokens.length) return 60;
    if(hits>0) return 40+(hits/qTokens.length)*20;
    // Levenshtein-based for short words
    if(query.length<=6){
      var dist=levenshtein(str.substring(0,query.length+3),query);
      if(dist<=1) return 50;
      if(dist<=2) return 30;
    }
    return 0;
  }

  function levenshtein(a,b){
    var m=a.length,n=b.length,dp=[];
    for(var i=0;i<=m;i++){dp[i]=[i];for(var j=1;j<=n;j++) dp[i][j]=0;}
    for(var j=0;j<=n;j++) dp[0][j]=j;
    for(var i=1;i<=m;i++) for(var j=1;j<=n;j++){
      dp[i][j]=a[i-1]===b[j-1]?dp[i-1][j-1]:1+Math.min(dp[i-1][j],dp[i][j-1],dp[i-1][j-1]);
    }
    return dp[m][n];
  }

  // ── Shopify Predictive Search ────────────────────────────────────
  function doSearch(q){
    q=normalizePublicSearchQuery(q);
    var url="/search/suggest.json?q="+encodeURIComponent(q)+"&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag";
    fetch(url)
      .then(function(r){return r.json();})
      .then(function(data){renderResults(q,data);})
      .catch(function(){renderFallback(q);});
  }

  function renderResults(q,data){
    if(suggestions) suggestions.hidden=true;
    results.hidden=false;
    results.innerHTML="";

    var products=((data.resources&&data.resources.results&&data.resources.results.products)||[]).filter(isProductSearchable);
    var collections=(data.resources&&data.resources.results&&data.resources.results.collections)||[];

    // Fuzzy re-rank products
    products=products.map(function(p){
      var score=Math.max(
        fuzzyScore(p.title||"",q),
        fuzzyScore(p.vendor||"",q),
        fuzzyScore((p.product_type||""),q)
      );
      return Object.assign({},p,{_score:score});
    }).filter(function(p){return p._score>0||products.length<5;})
      .sort(function(a,b){return b._score-a._score;});

    if(products.length===0&&collections.length===0){
      var fallbackLinks=suggestedSearchLinks(q).map(function(link){
        return "<a href=\""+link.url+"\" class=\"search-suggestion\">"+escHtml(link.title)+"</a>";
      }).join("");
      var routedUrl=routedSearchUrl(q);
      results.innerHTML="<div class=\"search-no-results\">No results for &ldquo;"+escHtml(q)+"&rdquo;</div><div class=\"search-overlay__suggestions\"><span class=\"search-suggestions__label\">Try</span>"+fallbackLinks+"</div><a href=\""+(routedUrl||("/search?q="+encodeURIComponent(q)))+"\" class=\"search-all-link\">See all results &rarr;</a>";
      return;
    }

    var html="";

    if(products.length){
      html+="<div class=\"search-results__group-label\">Products</div>";
      products.slice(0,6).forEach(function(p){
        var img=p.featured_image&&p.featured_image.url?
          "<img src=\""+p.featured_image.url+"&width=80\" alt=\""+escHtml(p.title)+"\" width=\"40\" height=\"40\" loading=\"lazy\">":
          "<div class=\"search-result__img-placeholder\"></div>";
        var price=(p.price_min||p.price)?formatMoney(p.price_min||p.price):"";var priceDisplay=price?(price+(p.price_max&&p.price_max!==p.price_min?"":"")):"";
        html+="<a href=\""+p.url+"\" class=\"search-result\" role=\"option\">"
          +"<div class=\"search-result__img\">"+img+"</div>"
          +"<div class=\"search-result__info\">"
            +"<span class=\"search-result__title\">"+highlight(escHtml(p.title),q)+"</span>"
            +(p.vendor?"<span class=\"search-result__vendor\">"+escHtml(p.vendor)+"</span>":"")
          +"</div>"
          +(priceDisplay?"<span class=\"search-result__price\">"+priceDisplay+"</span>":"")
          +"</a>";
      });
    }

    if(collections.length){
      html+="<div class=\"search-results__group-label\">Collections</div>";
      collections.slice(0,3).forEach(function(c){
        html+="<a href=\""+c.url+"\" class=\"search-result search-result--collection\" role=\"option\">"
          +"<div class=\"search-result__img\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><rect x=\"2\" y=\"2\" width=\"9\" height=\"9\" rx=\"1\" stroke=\"#C8922A\" stroke-width=\"1.5\"/><rect x=\"13\" y=\"2\" width=\"9\" height=\"9\" rx=\"1\" stroke=\"#C8922A\" stroke-width=\"1.5\"/><rect x=\"2\" y=\"13\" width=\"9\" height=\"9\" rx=\"1\" stroke=\"#C8922A\" stroke-width=\"1.5\"/><rect x=\"13\" y=\"13\" width=\"9\" height=\"9\" rx=\"1\" stroke=\"#C8922A\" stroke-width=\"1.5\"/></svg></div>"
          +"<div class=\"search-result__info\"><span class=\"search-result__title\">"+escHtml(c.title)+"</span><span class=\"search-result__vendor\">Collection</span></div>"
          +"</a>";
      });
    }

    html+="<a href=\""+(routedSearchUrl(q)||("/search?q="+encodeURIComponent(q)+"&type=product"))+"\" class=\"search-all-link\">See all results for &ldquo;"+escHtml(q)+"&rdquo; &rarr;</a>";
    results.innerHTML=html;
  }

  function renderFallback(q){
    results.hidden=false;
    results.innerHTML="<a href=\""+(routedSearchUrl(q)||("/search?q="+encodeURIComponent(q)+"&type=product"))+"\" class=\"search-all-link\">Search for &ldquo;"+escHtml(q)+"&rdquo; &rarr;</a>";
  }

  function highlight(str,q){
    var re=new RegExp("("+q.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")+")","gi");
    return str.replace(re,"<mark>$1</mark>");
  }
  function escHtml(s){return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}
  function formatMoney(p){var n=parseFloat(p);if(isNaN(n))return "";return "$"+n.toFixed(2);}

})();
});
